<template>
    <model-modal
        :model-class="modelClass"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <template  v-if="slotProps.model">
                <h2 class="flex items-center mb-8 text-xl font-medium cursor-pointer text-gray-800 hover:text-gray-900" @click="editDocument">
                    {{ slotProps.model.number }}
                    <i class="inline-block px-2 ml-2 text-xs text-gray-600 hover:text-gray-800 fas fa-pencil"></i>
                </h2>
    
                <div class="mb-4">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.total') }}</p>
                    <p class="text-gray-900">{{ slotProps.model.amount | price }}</p>
                </div>
    
                <div class="mb-4" v-if="slotProps.model.external_source">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.source') }}</p>
                    <a class="text-gray-900 hover:underline hover:text-black" href="#" @click.prevent="slotProps.model.openExternalSource()">
                        {{ $t(`worksite.profitability.document_modal.sources.${slotProps.model.external_source}`) }}
                    </a>
                </div>
    
                <div class="mb-4" v-if="slotProps.model.type == 'invoice'">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.status') }}</p>
                    <p class="text-gray-900">{{ $t(`worksite.profitability.document_status.${slotProps.model.status}`) }}</p>
                </div>
    
                <div class="mb-4" v-if="slotProps.model.profitability_type == 'costs'">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.cost_type') }}</p>
                    <p class="text-gray-900">{{ $t(`worksite.profitability.cost_type.${slotProps.model.type}`) }}</p>
                </div>
    
                <div class="mb-4">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.creation_date') }}</p>
                    <p class="text-gray-900">
                        {{ $t('misc.datetime', {
                            date: $moment(slotProps.model.created_at).format('DD MMMM YYYY'),
                            time: $moment(slotProps.model.created_at).format('HH[h]mm')
                        }) }}
                    </p>
                </div>
    
                <div class="mb-4">
                    <p class="text-sm text-gray-600">{{ $t('worksite.profitability.document_modal.added_by') }}</p>
                    <p class="text-gray-900" v-if="$store.getters.getUserName(slotProps.model.user_id)">{{ $store.getters.getUserName(slotProps.model.user_id) }}</p>
                    <p class="text-gray-900" v-else>{{ $t('worksite.profitability.document_modal.added_by_not_found') }}</p>
                </div>
    
                <!-- <div class="mb-4" v-if="slotProps.model.pdf">
                    <iframe class="w-full h-[500px]" :src="slotProps.model.pdf" frameborder="0"></iframe>
                </div> -->
                
                <div class="mb-4" v-if="slotProps.model.pdf">
                    <v-spa-loading-button v-if="slotProps.model.pdf" @clicked="slotProps.model.download()">
                        {{ $t('worksite.profitability.document_modal.download_button') }}
                    </v-spa-loading-button>
                </div>
                
                <div>
                    <a href="#" :class="$spa.css.button.color.delete_link" @click.prevent="deleteProfitabilityDocument">
                        {{ $t('worksite.profitability.document_modal.delete_button') }}
                    </a>
                </div>
            </template>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksiteProfitabilityDocument from '@spa/apps/trustup-pro-worksite-js/models/WorksiteProfitabilityDocument';

    export default {
        components: {
            ModelModal
        },

        data() {
            return {
                modelClass: WorksiteProfitabilityDocument
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },
        },

        methods: {
            editDocument()
            {
                this.model.edit();
                this.$refs.modal.close();
            },

            async deleteProfitabilityDocument()
            {
                await this.model.getEndpoint().delete(this.model.uuid);

                this.$refs.modal.close();
            }
        }
    }
</script>